__turbopack_context__.v({
  "modal-content": "pdf-download-modal-content-module-scss-module__xBjGyG__modal-content",
  "modal-content--preview": "pdf-download-modal-content-module-scss-module__xBjGyG__modal-content--preview",
  "modal-content__download-container": "pdf-download-modal-content-module-scss-module__xBjGyG__modal-content__download-container",
  "modal-content__form": "pdf-download-modal-content-module-scss-module__xBjGyG__modal-content__form",
  "modal-content__iframe": "pdf-download-modal-content-module-scss-module__xBjGyG__modal-content__iframe",
  "modal-content__preview-button": "pdf-download-modal-content-module-scss-module__xBjGyG__modal-content__preview-button",
  "modal-content__preview-button-icon": "pdf-download-modal-content-module-scss-module__xBjGyG__modal-content__preview-button-icon",
});
